import React from 'react';
import styles from './section.module.scss';
export var FilterSection = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement("div", { className: styles['section-body'] },
        React.createElement("div", { className: styles['section-title'] }, title),
        children));
};
